import { build } from './SliderBuilder';
import { register } from '../core/bootstrapper';

register(null, function () {

    $(document).ready(function () {
        build();
    });

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/sliders/slidersBootstrap.js
 **/